<template>
   
  <div>
    <div v-if="generic && generic.drug_insured" class="sa-d-f-a-center sa-mt20">
      <span class="sa-mr10">
        <input type="radio" id="ins" value="Ins" v-model="picked" @click="changeRadio($event)">
        <label for="ins">Insurance covered meds</label>
      </span>
      <span>
        <input type="radio" id="nins" value="NIns" v-model="picked" @click="changeRadio($event)">
        <label for="nins">Non Insurance meds</label>
      </span>
    </div>
    <div class="sa-row sa-mt20 sa-d-f-a-center">
      <div class="sa-col-xs12 sa-col-sm5 sa-col-md5 sa-col-lg4">
        <div class="sa-form-group">
          <input
            type="text"
            class="sa-form-control sa-dark-search"
            placeholder="Search Drugs"
            v-model="drug_search"
            @input="changeType"
          /><i class="icon-search sa-search"></i>
        </div>
      </div>
    </div>
    <ul class="sa-infinite sa-infinite-height">
       <li  v-if="drugnames && drugnames.length" v-for="(item, index) in drugnames" :key="index">
          <input :value="item" v-model="drug_name" type="radio" :id="index" :name="index">
          <label :for="index">{{item}}</label>
        </li>
        
      <!-- <li>
        {{drug_names}}
        <input type="radio" :id="index" :name="index" />
        <label :for="index">assd</label>
      </li> -->

    <infinite-loading :identifier="infiniteId" @infinite="getDrugData" spinner="waveDots">
      <span slot="no-results">No results</span>
      <span slot="no-more"></span>
    </infinite-loading>
    </ul>
    <div class="sa-ftr-btn">
      <button @click="goback()" class="sa-btn-large sa-btn-primary sa-btn-block-xs">
        Continue
      </button>
    </div>
  </div>
</template>
<script>
import InfiniteLoading from "vue-infinite-loading";
import { pro_url, oh_url } from "../../../../../config/endpoints";
import axios from 'axios';
import ContentLoaderVue from "../../../../components/common/ContentLoader.vue";
const api = '//hn.algolia.com/api/v1/search_by_date?tags=story';
export default {
props: ['generic','drugs'],
components: {
    "infinite-loading": InfiniteLoading,
    "content-loader": ContentLoaderVue,
  },
data() {
  return {
    drug_name : null,
    drug_search: "",
    drugnames: [],
    infiniteId: +new Date(),
    page: 1,
    picked:"Ins",
    loader:false,
    drug_insured: this.generic && this.generic.drug_insured ? this.generic.drug_insured: false,
    provider_code: this.generic && this.generic.provider_code ? this.generic.provider_code : null
  }
},
mounted(){
},
methods: {
   goback(){
    if(this.drug_name){
      this.$parent.$parent.drugObj.drug_nm = this.drug_name
      this.$parent.$parent.drugObj.ins_med = (this.drug_insured && this.picked == "Ins")? true: false
    }
    this.$parent.$parent.DrugNameFlag = false
  },
  changeRadio(e){
    this.picked = e.target.value
    this.page = 1;
    this.drugnames = []
    this.getDrugData()
  },
  changeType() {
      this.page = 1;
      this.drugnames = [];
      this.infiniteId += 1;
    },
   infiniteHandler($state) {
      axios.get(api, {
        params: {
          page: this.page,
        },
      }).then(({ data }) => {
        if (data.hits.length) {
          this.page += 1;
          //this.list.push(...data.hits);
          this.drugnames.push(...data.hits);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    getDrugData($state) {
    let _self = this
    _self.loader = true
     let data = {
          limit: 30,
	        page: this.page,
          drug_search: this.drug_search
          }
      if(this.drugs && this.drugs.scientific_name){
        data.scientific_name = this.drugs.scientific_name
      }  
      let  uri = `${oh_url}/general/drugsList` 
      if(_self.drug_insured && _self.provider_code && _self.picked =="Ins"){
        uri = `${oh_url}/general/drugsListV1` 
        data.insured = _self.drug_insured
        data.provider_code = _self.provider_code
      }else if(_self.drug_insured && _self.picked =="NIns"){
        uri = `${oh_url}/general/drugsListV1` 
        data.insured = _self.drug_insured
      }
      _self.$store
        .dispatch("httpPost", {
          uri: uri,
          body: data,
        })
        .then((response) => {
          if ((response.status === 1000)) {
            if (response && response.status === 1000 && response.data && response.data.data && response.data.data.drug_names && response.data.data.drug_names.length) {
               // _self.list =_.uniqBy(_self.list, function(o){ return o.icd10_code;});
                _self.page += 1
                //_self.list.push(...response.data.data);


                // for filering out the duplicate scientific names
                const uniqueNames = new Set([..._self.drugnames, ...response.data.data.drug_names]);
                _self.drugnames = [...uniqueNames];
                // _self.drugnames.push(...response.data.data.drug_names);
                //_self.drugnames = response.data.data.drug_names;
                _self.loader = false
                $state.loaded()
              } else {
                  $state.complete()
              }
            // _.map(response.data, (e) => {
            //   this.scientifics.push(e.scientifi_names)
            //   this.drugs.push(e.drug_names);
            //   return e;
            // });
          }
        })
        .catch((e) => {
          // console.log(e)
        });
    },
}
}
</script>